'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cycler = exports.mediaBreakpoints = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.externalLinks = externalLinks;
exports.wrapTables = wrapTables;
exports.wrapIframes = wrapIframes;
exports.wrapImages = wrapImages;
exports.getOffsetTop = getOffsetTop;
exports.getOffsetLeft = getOffsetLeft;
exports.scrollToY = scrollToY;
exports.debounce = debounce;
exports.slideDown = slideDown;
exports.slideUp = slideUp;

var _functional = require('./functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function externalLinks() {
  var links = (0, _functional.getElements)('a');

  // If the link starts with any of these things, we'll open a 600x300 popup
  // window for them.
  var usePopupPrefixes = ['https://twitter.com/intent/tweet?', 'https://www.facebook.com/sharer.php?', 'https://www.linkedin.com/shareArticle?'];

  var thisDomain = window.location.hostname.indexOf('www.') === 0 ? window.location.hostname.substr(4) : window.location.hostname;

  links.forEach(function (link) {
    var href = link.getAttribute('href');

    if (!href || href.indexOf('mailto:') >= 0 || (0, _functional.doesStringContainAny)(href, ['http://', 'https://', '//']) === false) {
      return;
    }

    var domain = link.hostname.indexOf('www.') === 0 ? link.hostname.substr(4) : link.hostname;

    if (domain !== thisDomain) {
      link.setAttribute('target', '_blank');
      // Add noopener and 'noreferrer' to work around this:
      // https://dev.to/ben/the-targetblank-vulnerability-by-example
      var rel = link.getAttribute('rel');

      if (!rel) {
        // will be null if it is not set
        rel = '';
      }

      link.setAttribute('rel', rel + ' noopener noreferrer');
    }

    // Use a popup for social sharing links.
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = usePopupPrefixes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prefix = _step.value;

        if (href.indexOf(prefix) === 0) {
          link.addEventListener('click', function (event) {
            event.preventDefault();
            window.open(href, '_blank', 'width=600,height=300,menubar=0,toolbar=0,status=0');
          });

          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
} /*
   External links (defined as all links pointing to a domain that is not the
   same as the one from which the current document is being served)
   will have their 'target' attribute set to '_blank'.
   Social media sharing links will show in a popup.
   */
function wrapTables() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$elements = _ref.elements,
      elements = _ref$elements === undefined ? [] : _ref$elements,
      _ref$wrapClass = _ref.wrapClass,
      wrapClass = _ref$wrapClass === undefined ? 'rte-RichText_Table' : _ref$wrapClass;

  elements.forEach(function (el) {
    var div = (0, _functional.createElement)('div', {
      class: wrapClass
    });
    div.innerHTML = el.outerHTML;
    el.parentNode.insertBefore(el, div);
    el.remove();
  });
}

function wrapIframes() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$elements = _ref2.elements,
      elements = _ref2$elements === undefined ? [] : _ref2$elements,
      _ref2$wrapClass = _ref2.wrapClass,
      wrapClass = _ref2$wrapClass === undefined ? 'rte-RichText_Iframe' : _ref2$wrapClass;

  elements.forEach(function (el) {
    var div = (0, _functional.createElement)('div', {
      class: wrapClass
    });
    div.innerHTML = el.outerHTML;
    el.parentNode.insertBefore(el, div);
    el.remove();

    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    var newIframe = (0, _functional.getElement)('iframe', div);
    newIframe.setAttribute('src', newIframe.getAttribute('src'));
  });
}

function wrapImages() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$elements = _ref3.elements,
      elements = _ref3$elements === undefined ? [] : _ref3$elements,
      _ref3$wrapClass = _ref3.wrapClass,
      wrapClass = _ref3$wrapClass === undefined ? 'rte-RichText_Images' : _ref3$wrapClass,
      _ref3$putAltTextAsCap = _ref3.putAltTextAsCaption,
      putAltTextAsCaption = _ref3$putAltTextAsCap === undefined ? true : _ref3$putAltTextAsCap;

  elements.forEach(function (image) {
    if (image.parentNode.classList.contains('art-Article_ShopImage') === false) {
      if (putAltTextAsCaption) {
        var hasAltText = function hasAltText(image) {
          return image.hasAttribute('alt');
        };
        var getAltText = function getAltText(image) {
          return image.getAttribute('alt');
        };

        if (hasAltText(image) === false) return;

        var caption = (0, _functional.createElement)('p');
        caption.textContent = getAltText(image);

        var div = (0, _functional.createElement)('div', {
          class: wrapClass
        });
        div.innerHTML = image.outerHTML;
        div.appendChild(caption);

        var parentDiv = (0, _functional.createElement)('div', {
          class: 'rte-RichText_Images-flex'
        });
        parentDiv.innerHTML = div.outerHTML;

        image.parentNode.insertBefore(parentDiv, image);
        image.remove();
      }
    }
  });
}

/*
 Media breakpoints
 */
var mediaBreakpoints = exports.mediaBreakpoints = {
  xs: 480,
  sm: 768,
  md: 900,
  lg: 1200,
  xlg: 1440,
  xxlg: 1600
};

function getOffsetTop(el) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  var offsetTop = 0;

  do {
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop;
    }

    el = el.offsetParent;
  } while (el !== parent || el !== document.body);

  return offsetTop;
}

function getOffsetLeft(el) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  var offsetLeft = 0;

  do {
    if (!isNaN(el.offsetLeft)) {
      offsetLeft += el.offsetLeft;
    }

    el = el.offsetParent;
  } while (el !== parent || el !== document.body);

  return offsetLeft;
}

function scrollToY() {
  var scrollTargetY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'easeInOutQuint';

  var scrollY = window.scrollY;
  var currentTime = 0;

  var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));

  var easingEquations = {
    easeOutSine: function easeOutSine(pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function easeInOutSine(pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function easeInOutQuint(pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    }
  };

  function tick() {
    currentTime += 1 / 60;

    var position = currentTime / time;
    var t = easingEquations[easing](position);

    if (position < 1) {
      window.requestAnimationFrame(tick);

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }

  tick();
}

var Cycler = exports.Cycler = function () {
  function Cycler(items) {
    (0, _classCallCheck3.default)(this, Cycler);

    this.items = items;
    this.currentPosition = 0;
  }

  (0, _createClass3.default)(Cycler, [{
    key: 'current',
    value: function current() {
      return this.items[this.currentPosition];
    }
  }, {
    key: 'set',
    value: function set(val) {
      this.currentPosition = val;
    }
  }, {
    key: 'prev',
    value: function prev() {
      var current = this.current();
      this.currentPosition = this.currentPosition - 1;

      if (this.currentPosition < 0) this.currentPosition = this.items.length - 1;

      return current;
    }
  }, {
    key: 'next',
    value: function next() {
      var current = this.current();
      this.currentPosition = (this.currentPosition + 1) % this.items.length;

      return current;
    }
  }]);
  return Cycler;
}();

function debounce(func, wait, immediate) {
  var timeout = void 0;

  return function () {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function slideDown(el, end) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$start = _ref4.start,
      start = _ref4$start === undefined ? 0 : _ref4$start,
      _ref4$easing = _ref4.easing,
      easing = _ref4$easing === undefined ? 'easeInOutQuint' : _ref4$easing,
      _ref4$speed = _ref4.speed,
      speed = _ref4$speed === undefined ? 300 : _ref4$speed;

  var currentPosition = 0;
  var time = Math.max(0.1, Math.min(Math.abs(end) / speed, 0.8));
  var easingEquations = {
    easeOutSine: function easeOutSine(pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine: function easeInOutSine(pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint: function easeInOutQuint(pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5);
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2);
    }
  };

  return new Promise(function (resolve, reject) {
    var tick = function tick() {
      currentPosition += 1 / 60;
      var position = currentPosition / time;
      var t = easingEquations[easing](position);

      if (position < 1) {
        window.requestAnimationFrame(tick);

        el.style.height = currentPosition + (end - currentPosition) * t + 'px';
      } else {
        el.style.height = end + 'px';

        resolve();
      }
    };

    tick();
  });
}

function slideUp(el, start) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$end = _ref5.end,
      end = _ref5$end === undefined ? 0 : _ref5$end,
      _ref5$easing = _ref5.easing,
      easing = _ref5$easing === undefined ? 'easeInOutQuint' : _ref5$easing,
      _ref5$speed = _ref5.speed,
      speed = _ref5$speed === undefined ? 300 : _ref5$speed;

  var currentPosition = 0;
  var time = Math.max(0.1, Math.min(Math.abs(start) / speed, 0.8));
  var easingEquations = {
    easeOutSine: function easeOutSine(t) {
      return Math.sin(t * (Math.PI / 2));
    },
    easeInOutSine: function easeInOutSine(t) {
      return -0.5 * (Math.cos(Math.PI * t) - 1);
    },
    easeInOutQuint: function easeInOutQuint(t) {
      return (t /= 0.5) < 1 ? 0.5 * Math.pow(t, 5) : 0.5 * (Math.pow(t - 2, 5) + 2);
    }
  };

  return new Promise(function (resolve, reject) {
    var tick = function tick() {
      currentPosition += 1 / 60;
      var position = currentPosition / time;
      var t = easingEquations[easing](position);

      if (position < 1) {
        window.requestAnimationFrame(tick);

        el.style.height = start - (start - end) * t + 'px';
      } else {
        el.style.height = end + 'px';

        resolve();
      }
    };

    tick();
  });
}